export const CrossborderFormSection = ({ title, children, className = "" }) => (
  <section className={className}>
    {title && (
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-gray-400">{title}</p>
    )}
    {children}
  </section>
);
